// Zen Complex — botón «Añadir» de los productos sugeridos del carrito.
// Replica el flujo de product-form.js de Horizon para que el carrito se
// actualice (morph de la sección) sin recargar la página.
import { CartLinesUpdateEvent } from '@shopify/events';

const getSectionIds = () =>
  [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
    .filter(Boolean);

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element && event.target.closest('[data-zc-upsell-add]');
  if (!button || button.disabled) return;
  event.preventDefault();

  const variantId = button.getAttribute('data-zc-upsell-add');
  const label = button.textContent;
  button.disabled = true;
  button.classList.add('is-loading');

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'upsell',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    body.append('sections', getSectionIds().join(','));

    const response = await fetch(`${window.Theme?.routes?.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body,
    }).then((r) => r.json());

    const ajaxCart = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`).then((r) => r.json());

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: {
        items: ajaxCart.items,
        source: 'zc-cart-upsell',
        itemCount: 1,
        sections: response.sections,
        didError: Boolean(response.status),
      },
    });
  } catch (error) {
    deferred.reject(error);
    button.disabled = false;
    button.classList.remove('is-loading');
    button.textContent = label;
  }
});
